import useBrainSearchBot from "@/admin/integrations/chat-bot/util/useBrainSearchBot"
import { useGlobalDrawer } from "@/core/context/GlobalDrawerProvider"
import makeUseStyles from "@assets/style/util/makeUseStyles"
import { DiscoDrawer } from "@disco-ui"
import lazyWithRetry from "@utils/lazy/lazyWithRetry"

const BrainSearchDrawerContent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "brain-search-drawer-content" */ "@/brain-search/internal/drawer/BrainSearchDrawerContent"
    )
)

function BrainSearchDrawer() {
  const drawer = useGlobalDrawer("brainSearch")
  const classes = useStyles()
  const brainSearchBot = useBrainSearchBot()
  if (!brainSearchBot) return null

  return (
    <DiscoDrawer
      open={drawer.isOpen}
      fullScreen
      onClose={drawer.close}
      containerClasses={{ drawerContainer: classes.drawer }}
    >
      {drawer.isOpen && <BrainSearchDrawerContent />}
    </DiscoDrawer>
  )
}

const useStyles = makeUseStyles({
  drawer: {
    padding: 0,
    display: "flex",
    overflow: "hidden",
  },
})

export default BrainSearchDrawer
